import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import ProductCard from "./ProductCard";
import { useTranslation } from "react-i18next";
import "swiper/css";
import "swiper/css/navigation";

const RecommendedOne = ({ popularProducts = [] }) => {
  const { t } = useTranslation();

  return (
    <section className="recommended margin-100 newSlickStyle">
      <div className="container">
        {/* Section Header */}
        <div className="section-heading flex-between flex-wrap">
          <h5 className="mb-0">{t("featuredProducts")}</h5>
          <Link
            to="/products"
            className="btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
          >
            {t("shopNow")}
            <span className="icon text-xl d-flex">
              <i className="ph ph-arrow-right"></i>
            </span>
          </Link>
        </div>

        {/* Swiper Slider */}
        {popularProducts.length > 0 && (
          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={4}
            autoplay={{ delay: 3000 }}
            speed={1000}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop={true}
            breakpoints={{
              1599: { slidesPerView: 4 },
              1399: { slidesPerView: 4 },
              992: { slidesPerView: 4 },
              575: { slidesPerView: 2 },
            }}
          >
            {popularProducts.map((item) => (
              <SwiperSlide key={item._id}>
                <ProductCard item={item} className="" />
              </SwiperSlide>
            ))}

            {/* Navigation Buttons */}
            <div className="swiper-button-next custom-arrow">
              <i className="ph ph-caret-right"></i>
            </div>
            <div className="swiper-button-prev custom-arrow">
              <i className="ph ph-caret-left"></i>
            </div>
          </Swiper>
        )}
        {popularProducts.length === 0 && <div className="text-center">
              <img className="" src="/assets/images/grey.png" alt="" />
              <p className="">The data is not available for the region you are from.</p>
            </div>}
      </div>
    </section>
  );
};

export default RecommendedOne;
